angular.module('gym.access_control', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.access_control', {
    url: '/access_control',
    abstract: true,
    template: '<ui-view>'
  }).state('gym.access_control.optIn', {
    url: '/settings/toggle',
    controller: 'AccessControlOptInCtrl',
    template: require('templates/gyms/access_control/toggle.html.slim'),
    resolve: {
      planData: ["$stateParams", "$http", function($stateParams, $http) {
        var url;
        url = `/subscription_plans?gymId=${$stateParams.gymId}`;
        return $http.get(url).then(function(response) {
          return response.data.plan_data;
        });
      }]
    }
  }).state('gym.access_control.settings', {
    url: '/settings',
    controller: 'AccessControlSettingsCtrl',
    template: require('templates/gyms/access_control/settings.html.slim'),
    resolve: {
      settings: ["AccessControl", function(AccessControl) {
        return AccessControl.all('settings').getList();
      }]
    }
  });
}]);
